import T, { t } from '../../../../common/components/T';
import css from './AccountActivation.module.scss';

export const thead = {
    data: [
        {
            type: 'text',
            title: <T textName='name' defaultStr='Название' page='/store/register' />,
            name: 'name'
        },
        {
            type: 'counter',
            title: <T textName='qty' defaultStr='Кол-во' />,
            name: 'quantity'
        },
        {
            type: 'text',
            title: <T textName='currency_price' defaultStr='Цена в валюте' />,
            name: 'currency_price'
        },
        {
            type: 'text',
            title: <T textName='price_in_marketings' defaultStr='Баллы' />,
            name: 'price'
        }
    ]
};

export const packageThead = {
    data: [
        {
            type: 'text',
            title: <T textName='name' defaultStr='Название' page='/store/register' />,
            name: 'name'
        },
        {
            type: 'text',
            title: <T textName='qty' defaultStr='Кол-во' />,
            name: 'quantity'
        },
        {
            type: 'text',
            title: <T textName='currency_price' defaultStr='Цена в валюте' />,
            name: 'currency_price'
        },
        {
            type: 'text',
            title: <T textName='price_in_marketings' defaultStr='Баллы' />,
            name: 'price',
            noWrap: true
        }
    ]
};

export const transformData = (translation) => (data) => {
    const createName = (item) => {
        return (
            <>
                <p className={css.packageName}>{item.name}</p>
                {item?.set_products ? (
                    <div className={css.packageProducts}>
                        {item?.set_products?.map((prod) => (
                            <p key={prod.id}>{`${prod.name} - ${prod.count} ${t('pc', 'шт', 'all', translation)}`}</p>
                        ))}
                    </div>
                ) : null}
            </>
        );
    };

    return {
        data: data?.map((item) => {
            const product = item.product;
            return {
                name: product?.type === 'set' ? createName(product) : product?.name,
                quantity: item?.quantity || 1,
                currency_price: product?.price?.price_for_currency_formatted,
                price: product?.price?.price_for_client_formatted,
                id: product.id
            };
        })
    };
};
